import { OnInit, OnDestroy, Directive, Input, ElementRef } from '@angular/core';
import * as moment from 'moment';

@Directive({
    selector: '[now]'
})
export class NowDirective implements OnInit, OnDestroy {

    @Input() format;
    intervalId;

    constructor(public element: ElementRef) { }

    ngOnInit() {
        this.updateTime();
        this.intervalId = setInterval(this.updateTime.bind(this), 1000);
    }

    updateTime() {
        let dt = moment().format(this.format);
        this.element.nativeElement.innerHTML = dt;
    }

    ngOnDestroy() {
        clearInterval(this.intervalId);
    }

}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/shared/directives/now/now.directive.ts